import React, { useMemo } from 'react';
import { useReframe } from 'nike-re-framejs';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { isLoggedIn } from '@/account';
import { loggedRedirects, notLoggedRedirects } from '@/routing/loggedRedirects';
import redirects from '@/routing/redirects';
import * as routes from '@/routing/routes';
import { HOME } from '@/routing/routes';
import { getSpecialLayoutRoutes } from '@/routing/route-groups';
import { NikeRouteContextProvider } from 'nike-ui/src/common/routing/NikeRouteContext';
import ForcePasswordForm from '@/myprofile/views/password/ForcePasswordForm';
import ObjectValues from '@/common/ObjectValues';
import { accountShouldForceChangePassword$ } from '@/account/subs';
import { hasQueryParam } from '@/routing/QueryParamRoute';
import LoginOverlay from '@/loginng/views/LoginDialog';

function addRedirects(redirects) {
    return redirects.reduce((ret, { from, to }) => {
        ret.push(<Redirect key={from} from={from} to={to} />);
        return ret;
    }, []);
}

function escape(path) {
    return path.replace(/:/g, '\\:');
}

export function MainSwitch({ render }) {
    const { pathname, search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);
    const queryRedirect = query.get('redirect');
    const { subscribe } = useReframe();
    const shouldForceChangePassword = subscribe(accountShouldForceChangePassword$);
    if (shouldForceChangePassword) {
        return <ForcePasswordForm />;
    }
    return (
        <Switch>
            <Redirect from="/:url*(/+)" to={escape(pathname.slice(0, -1))} />
            <Route
                key="static:route:key"
                path="/"
                exact
                render={({ match, location, history }) => (
                    <NikeRouteContextProvider activeRoute={HOME} routeParams={match.params}>
                        {render(HOME, match, location, history)}
                    </NikeRouteContextProvider>
                )}
            />
            {(isLoggedIn() ? loggedRedirects(queryRedirect) : notLoggedRedirects).map(([path, to]) => (
                <Redirect key={path} from={path} to={to} />
            ))}

            {addRedirects(redirects)}

            {ObjectValues(routes).map(route => {
                const PageComponent = route.component;
                return route.component ? (
                    <Route
                        key="static:route:key"
                        path={route.path}
                        render={({ match, location, history }) => (
                            <NikeRouteContextProvider activeRoute={route} routeParams={match.params}>
                                {getSpecialLayoutRoutes().includes(route) ? (
                                    <>
                                        <main id="page" role="main">
                                            <PageComponent route={route} {...match.params} history={history} />
                                        </main>
                                        {hasQueryParam(location, 'prihlasenie') && !isLoggedIn() ? (
                                            <LoginOverlay />
                                        ) : null}
                                    </>
                                ) : (
                                    render(route, match, location, history)
                                )}
                            </NikeRouteContextProvider>
                        )}
                    />
                ) : null;
            })}
        </Switch>
    );
}

export default MainSwitch;
